// ~/config/db.js
import firebase from 'firebase'
import { config } from './firebaseConfig'
firebase.initializeApp(config);
const fsdb = firebase.firestore();

if (process.env.VUE_APP_ENABLE_OFFLINE == 1) {
    fsdb.enablePersistence().catch(err => {
        if (err.code == 'failed-precondition') {
            alert('Multiple tabs open. Offline can be enabled in one tab at a time.');
        } else if (err.code == 'unimplemented') {
            alert("Browser doesn't support offline capability");
        }
    });
} else {
    // eslint-disable-next-line
    console.warn("Offline capability disabled in this environment : " + config.environment)
}

export const { db, storage } = { db: fsdb, storage: firebase.storage() }